import { Product, ProductPriceEdit } from '@app/core/models';
import { FetchProductDataFilters } from '@app/core/models/fetch-product-data-filters';
import {
  ProductCatalogFilterBreedSizevalues,
  ProductCatalogFilterLifestageValues,
  ProductCatalogFilterValues,
} from '@app/shared/components/product-catalog-filters/product-catalog-filters';
import { SpeciesCode, Tool } from '@app/shared/utils';
import { RangeType } from '@app/shared/utils/enums/rangeType.enum';
import { TerritoryType } from '@app/shared/utils/enums/territoryType';
import { createAction, props } from '@ngrx/store';

/**
 * Price Actions
 */
export const addPricesToUpdate = createAction('[Products] Add Prices to Update', props<{ prices: ProductPriceEdit[] }>());

export const removePackFromPriceListToUpdate = createAction(
  '[Products] Remove Pack from Price List to Update',
  props<{ productId: string; packEan: string }>(),
);

export const removePacksFromPriceListToUpdate = createAction(
  '[Products] Bulk Remove Packs from Price List to Update',
  props<{ products: { productId: string; packEan: string }[] }>(),
);

export const resetPriceListToUpdate = createAction('[Products] Reset Price List to Update');

export const setShowPriceListActions = createAction('[Products] Set Show Price List Actions', props<{ value: boolean }>());

export const updatePrices = createAction(
  '[Products] Update Prices',
  props<{
    withTracking: boolean;
    trackingShouldIncludeProductsInformation: boolean;
    updateAllPrices: boolean;
    productsToUpdate: ProductPriceEdit[];
  }>(),
);

export const resetProductsPricesState = createAction('[Products] Reset Prices State');

export const setPriceMargin = createAction('[Products] Set price margin value', props<{ priceMargin: number }>());

/**
 * All Product Actions
 */
export const getAllProducts = createAction(
  '[Products] Get All Products ',
  props<{ filterParams?: FetchProductDataFilters; tool?: Tool }>(),
);
export const getAllProductsSuccess = createAction('[Products] Get All Products Success', props<{ allProductList: Product[] }>());
export const getAllProductsFail = createAction('[Products] Get All Products Fail');

export const setFilteredProducts = createAction('[Products] Set Filtered Products');
export const setFilteredProductsSuccess = createAction(
  '[Products] Set Filtered Products Success',
  props<{ filteredProductList: Record<TerritoryType | string, Product[]> }>(),
);

/**
 * Products Filters Actions
 */
export const setProductFilters = createAction(
  '[Products Filters] Set Products Filters',
  props<{ filtersValues: ProductCatalogFilterValues & ProductCatalogFilterBreedSizevalues }>(),
);

export const updateSelectedCategories = createAction(
  '[Products Filters] Update Selected Categories',
  props<{ selectedCategories: (TerritoryType | RangeType)[] | null }>(),
);

export const addSelectedCategory = createAction(
  '[Products Filters] Add a Selected Category',
  props<{ category: TerritoryType | RangeType }>(),
);

export const removeSelectedCategory = createAction(
  '[Products Filters] Remove a Selected Category',
  props<{ category: TerritoryType | RangeType }>(),
);

export const setForcedProductFilters = createAction(
  '[Products Filters] Set Forced Product Filters',
  props<{ specieCode?: SpeciesCode; lifestageType?: ProductCatalogFilterLifestageValues }>(),
);

export const setProductTypeFilters = createAction(
  '[Products Filters] Set Product Type Filters',
  props<{ dry: boolean; wet: boolean; treats: boolean }>(),
);

/**
 * Products Catalog Actions
 */
export const setSelectedDryProductPackId = createAction('[Products Catalog] Set Dry Product Pack ID', props<{ packId: string }>());

export const setSelectedWetProductPackId = createAction('[Products Catalog] Set Wet Product Pack ID', props<{ packId: string }>());

export const setSelectedTreatsProductPackId = createAction('[Products Catalog] Set Treats Product Pack ID', props<{ packId: string }>());

export const setSelectedProduct = createAction(
  '[Products Catalog] Set Selected Product',
  props<{ selectedProduct: { product: Product; packId?: string }; setProductOnly?: boolean; allowMultipleSelection?: boolean }>(),
);

export const resetSelectedProduct = createAction('[Products Catalog] Reset Selected Product', props<{ productId: string }>());
export const resetAllSelectedProducts = createAction('[Products Catalog] Reset All Selected Products');

export const resetProductsState = createAction('[Products] Reset State');
